<div [class.active]="isOpen" class="title">{{title}}</div>
<ng-select #select  [items]="widgetTypes"   [searchable]="false" [(ngModel)]="widgetType" bindValue="value"
groupBy="group" class="widget-type-select" (ngModelChange)="modelChange.emit(widgetType)" (focus)="isOpen=true"
 (blur)="isOpen=false" placeholder="{{ 'Select' | i18next }}" dropdownPosition="bottom">
    <ng-template ng-optgroup-tmp let-item="item" let-index="index" >
     <div *ngIf="index!=0" class="group-separator"></div>
      {{item.group}}
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <div class="template"  matTooltipClass="tooltip-font-14"  [matTooltip]="tooltip(item)" [matTooltipDisabled]="false">
           <i class="icon fal" [class]="item.icon" [class.disabled]="item.disabled"></i>
           <div >{{item.label}}</div>
      </div>
    </ng-template>
</ng-select>
